import { bootstrapApplication } from '@angular/platform-browser';
import { MSAL_INSTANCE } from '@azure/msal-angular';
import { appConfig, MSALInstanceFactory } from './app/app.config';
import { App } from './app/app';

async function bootstrap() {
  const msalInstance = MSALInstanceFactory();
  await msalInstance.initialize();

  await bootstrapApplication(App, {
    providers: [
      ...appConfig.providers,
      { provide: MSAL_INSTANCE, useValue: msalInstance },
    ],
  });
}

bootstrap().catch(console.error);
